function DiwaIcon(props) {
  return (
    <svg id='DiwaIcon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27.915 26.981' {...props}>
      <path
        id='Tracciato_326'
        data-name='Tracciato 326'
        d='M-2042.951-1047.754l14.3-16.02-7.68-10.961-6.621,5.621-5.9-5.621-7.712,10.961Z'
        transform='translate(2056.565 1074.734)'
        fill='#fff'
      />
    </svg>
  )
}

export default DiwaIcon
